const DEFAULT_SIGNS = ['Ar', 'Ta', 'Ge', 'Cn', 'Le', 'Vi', 'Li', 'Sc', 'Sg', 'Cp', 'Aq', 'Pi'];

export function rotateSignLabels(startIndex = 0, signLabels = DEFAULT_SIGNS) {
  return Array.from({ length: signLabels.length }, (_, index) => signLabels[(startIndex + index) % signLabels.length]);
}

export function createPlanet(label, overrides = {}) {
  return {
    id: overrides.id ?? String(label).toLowerCase(),
    label,
    ...overrides,
  };
}

/**
 * Rotate bhava labels around the fixed North Indian layout (slot 1 = top/Lagna, then anticlockwise).
 * For standard lagna charts omit numberLabels instead - slots always show bhava 1..12; only signs rotate.
 */
export function rotateHouseNumbers(startNumber = 1) {
  const normalized = ((Number(startNumber) || 1) - 1 + 12) % 12;
  return Array.from({ length: 12 }, (_, index) => ((normalized + index) % 12) + 1);
}

export function createNorthIndianChartModel({
  startHouseNumber = null,
  signStartIndex = null,
  signLabels = DEFAULT_SIGNS,
  numberLabels = null,
  planetsByHouse = {},
  highlightedHouses = [],
  selectedHouse = null,
  titles = {},
  secondaryTitles = {},
  subtitles = {},
  metadataByHouse = {},
  houseMeta = {},
} = {}) {
  const resolvedNumberLabels = Array.isArray(numberLabels) ? numberLabels : startHouseNumber != null ? rotateHouseNumbers(startHouseNumber) : null;
  const resolvedSignLabels =
    signStartIndex != null ? rotateSignLabels(signStartIndex, signLabels) : Array.isArray(signLabels) ? signLabels : DEFAULT_SIGNS;
  const highlighted = new Set(highlightedHouses);

  return Array.from({ length: 12 }, (_, index) => {
    const house = index + 1;

    return {
      house,
      numberLabel: Array.isArray(resolvedNumberLabels) ? resolvedNumberLabels[index] : house,
      title: titles[house],
      secondaryTitle: secondaryTitles[house],
      subtitle: subtitles[house] ?? '',
      signLabel: resolvedSignLabels[index] ?? '',
      planets: planetsByHouse[house] ?? [],
      highlighted: highlighted.has(house),
      selected: selectedHouse === house,
      ...(metadataByHouse[house] ?? {}),
      ...(houseMeta[house] ?? {}),
    };
  });
}

export function createNorthIndianChartData({
  signStartIndex = null,
  signLabels = DEFAULT_SIGNS,
  numberLabels = null,
  planetsByHouse = {},
  highlightedHouses = [],
  selectedHouse = null,
  titles = {},
  secondaryTitles = {},
  subtitles = {},
  metadataByHouse = {},
  houseMeta = {},
} = {}) {
  return createNorthIndianChartModel({
    signStartIndex,
    signLabels,
    numberLabels,
    planetsByHouse,
    highlightedHouses,
    selectedHouse,
    titles,
    secondaryTitles,
    subtitles,
    metadataByHouse,
    houseMeta,
  });
}

export { DEFAULT_SIGNS };
